import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  boardName: '',
  stages: [],
  events: [],
  rows: [],
  filters: {
    startDate: '',
    endDate: '',
    stage: {},
    selectedBoard: null,
    skip: 0,
    limit: 10,
    suspendedNoDate: false,
    suspendedWithDate: false,
    reproved: false,
    canceled: false,
    modalities: {},
    emandamento: '',
    refreshAt: new Date()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/board/state/index.js